import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el MegaKit después de comprar?',
  a: 'Al completar el pago, recibís un correo con el enlace de descarga en menos de 5 minutos. Podés acceder desde cualquier dispositivo de forma inmediata.'
}, {
  q: '¿Sirve si recién comienzo como catequista?',
  a: 'Sí, especialmente. El kit está diseñado para que cualquier persona pueda tomar un recurso y usarlo de forma inmediata, sin experiencia previa. Las planificaciones completas (Pack PRO) son ideales para quienes se inician.'
}, {
  q: '¿Para qué edades está pensado?',
  a: 'Todos los recursos están diseñados para niños de 6 a 12 años. Las actividades contemplan distintos niveles de comprensión dentro de ese rango etario.'
}, {
  q: '¿Los 5 bonos están en las dos opciones?',
  a: 'Sí. Los 5 bonos están incluidos en ambas opciones sin costo extra. La diferencia del Pack PRO es el Tomo Exclusivo de 10 Planificaciones Completas.'
}, {
  q: '¿Puedo imprimirlo o solo usarlo en pantalla?',
  a: 'Podés hacer las dos cosas. Todos los recursos vienen en formato PDF optimizado tanto para impresión en color o blanco y negro, como para usar directamente en tablet o proyector.'
}, {
  q: '¿Qué diferencia tiene con recursos gratuitos de internet?',
  a: 'Los recursos gratuitos están dispersos, sin coherencia pedagógica ni espiritual. El MegaKit es un sistema curado y ordenado, donde cada actividad tiene un propósito claro. No buscás, directamente usás.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días para probarlo. Si no estás conforme por cualquier motivo, te devolvemos el 100% del dinero sin preguntas. Solo escribís al mail de contacto y listo.'
}, {
  q: '¿Por qué elegir el Pack PRO y no el estándar?',
  a: 'Si querés llegar al encuentro con absolutamente todo resuelto — incluyendo el objetivo, el versículo, la dinámica y la oración — el Pack PRO es para vos. Es ideal para quienes tienen poco tiempo de preparación o para catequistas que se inician.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-20 px-4 md:px-6 bg-cream-100" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <div className="text-center mb-8 md:mb-12" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-2 md:mb-4" data-id="element-93">
            Preguntas Frecuentes
          </h2>
          <div className="w-12 md:w-16 h-1 bg-gold-500 mx-auto mt-3 md:mt-4 rounded-full" data-id="element-94"></div>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-95">
          {faqs.map((faq, i) => <motion.div key={i} whileHover={{
          borderColor: '#c8a24a'
        }} className="bg-white rounded-xl border border-cream-200 overflow-hidden shadow-sm transition-colors" data-id="element-96">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none hover:bg-cream-50/50 transition-colors" data-id="element-97">
                <span className="font-bold text-navy-900 pr-4 text-sm md:text-base" data-id="element-98">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-99">
                  <ChevronDown className="w-5 h-5 text-gold-600 shrink-0" data-id="element-100" />
                </motion.div>
              </button>
              <AnimatePresence initial={false} data-id="element-101">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-102">
                    <div className="p-4 md:p-6 pt-0 text-navy-900/70 text-sm md:text-base leading-relaxed border-t border-cream-50" data-id="element-103">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}